<template>
  <div class="container my-5">
    <div class="text-center title-au font-weight-bold mb-4">About us</div>
    <p class="text-au"><b><i><q>
      <!-- Colours of the real world look really real when we watch them on a screen -->
      My most enjoyable moviegoing experiences have always been going to a movie theatre, sitting there and the lights go down and a film comes on the screen that you don't know everything about, and you don't know every plot turn and every character movement that's going to happen.																			
																				
      </q> –-- 
      <!-- Anthony Burgess, English writer and composer. -->
      Christopher Nolan, Director, Producer, Screenwriter	
      </i></b></p>
    <!-- <p class="text-au">Going to cinema theatres is like viewing the world around us and drawing inspiration to be happy. Movies through the work of fiction, biographies and drama, have helped in shaping our cultures, our ideologies and have inspired us all to be colourful in several ways and create a more humane world.</p>
    <p class="text-au">GoGoCinema was created with the same intent to empower cinema lovers to freely select the movie of their choice and draw inspiration. In a free society like ours, the freedom to consumers is all that matters. Through the GoGoCinema platform, movie fans can select a movie of their choice and also select a time that is convenient for them to watch.</p>
    <p class="text-au">GoGoCinema team (which is also a group of avid movie goers!) evolved from the idea that in today’s world consumer needs a plethora of services of his choice on demand and at ease.</p> -->

    <p class="text-au">
      Going to movies is like viewing the world around us on a big screen. Whether it's fiction, comedy, action or drama, movies have helped shape our cultures, our ideologies and have inspired and entertained us for over 100 years. 																									
    </p>

    <!-- <br/> -->
    <!-- <br/> -->
    <!-- <p class="text-au"><b><i>So how does it work?</i></b></p>  

    <p class="text-au">A movie fan can use the GoGoCinema  App. or its <u><a href="https://www.gogocinema.com" target="_blank" style="color:#000;">website (www.gogocinema.com)</a></u> to find a  movie he/she wants to watch from the huge library of movies of different genre made available.</p>
    <p class="text-au">The library consists of recent movies, classics, documentaries, faith-based content, etc. Once the movie is selected, the movie fan can select a cinema hall, date and time most suitable from the number of options available.</p>    
    <p class="text-au">Movie fan has an option of selecting between:</p>    
    <p class="text-au">- a <b>Crowdsourcing</b> option public screening which all other movie fans joining the screening created. For this screening to go ahead a minimum number of tickets have to be booked by a certain cut-off time.</p>
    <p class="text-au">- a <b>Private screening</b> option where the entire movie hall is booked exclusively for private screening on special occasions such as birthdays, etc which is usually not easily available.</p> -->
    <div class="col-md-10 mx-auto pt-md-5">
      <div class="row">
        <div class="col-md-2">
          <img
            class="img-fluid d-block mx-auto"
            src="@/assets/img/gogobg.png"
            width="169"
            height="auto"
          />
        </div>

        <div class="col-md-8 text-center px-0">
          <p class="title-au font-weight-bold mb-0">Want to learn more?</p>
          <p class="text-au font-weight-bold">Check out other links</p>
          <div class="row mt-5">
            <div class="col-md-6">
              <b-button
                to="/hiw"
                variant="none"
                class="btn-gogo d-flex justify-content-center align-items-center"
              >How it works</b-button>
            </div>
            <div class="col-md-6 mt-md-0 mt-3">
              <b-button
                to="/faqs"
                variant="none"
                class="btn-gogo justify-content-center d-flex align-items-center"
              >FAQs</b-button>
            </div>
          </div>
        </div>

        <div class="col-md-2">
          <img
            class="img-fluid d-block mx-auto"
            src="@/assets/img/gogobg1.png"
            width="169"
            height="auto"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "aboutus",
  directives: {
    // 'dragscroll': dragscroll
  },
  // beforeMount() {
  //   this.$router.replace({
  //     path: "/coming-soon"
  //   });
  // },

  components: {},

  data() {
    return {};
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pages/aboutus.vue